export default "__VITE_ASSET__CTVZJyyo__"